import { ActionType, getType } from 'typesafe-actions'
import * as actions from './actions'
import N from '../../utils/assert-never'

import { initial as initialState, Type as State } from './state'
import { toast } from 'react-toastify'

export type Action = ActionType<typeof actions>

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  switch (action.type) {
    case getType(actions.getUser):
      return {
        ...state,
        loading: true,
      }
    case getType(actions.getUserComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          return {
            ...state,
            ...action.payload.payload,
          }
        } else {
          toast.error(action.payload.payload.message, { autoClose: false })
          return state
        }
      } else {
        return state
      }
  }
  return N(action, state)
}
